<template>
  <app-modal v-bind="$attrs" class="confirm-modal-container" title="確認">
    <template v-slot:body="{ cancel, ok }">
      <v-card-text class="mb-5">
        <div>
          <div class="font-weight-bold mb-5">
            以下の拠点間のポリシー適用を削除します。よろしいですか？
          </div>
          <span class="mx-2"
            >{{ $filter.enumTo(data.srcZoneType, "zoneType") }}/{{
              data.srcZoneName
            }}</span
          >
          ⇒
          <span class="mx-2"
            >{{ $filter.enumTo(data.dstZoneType, "zoneType") }}/{{
              data.dstZoneName
            }}</span
          >
          <span class="font-weight-bold mx-3">削除</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="flat" color="primary" @click="ok">はい</v-btn>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ZoneRelationItem } from "@/apis/ZoneRelationApi";

export default defineComponent({
  name: "IntranetFwZoneRelationDelete",
  props: {
    data: {
      type: Object as PropType<ZoneRelationItem>,
      required: true,
    },
  },
});
</script>
